import { render, staticRenderFns } from "./ExecutePasswordReset.vue?vue&type=template&id=2bd16865&"
import script from "./ExecutePasswordReset.vue?vue&type=script&lang=ts&"
export * from "./ExecutePasswordReset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports